import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Dashboard from './pages/Dashboard';
import ClientDetail from './pages/ClientDetail';
import ResetPassword from './pages/ResetPassword';
import DemoBuilder from './pages/DemoBuilder';
import SignContract from './pages/SignContract';
import Onboarding from './pages/Onboarding';

function App() {
  const subdomain = (() => {
    const host = window.location.hostname;
    const parts = host.split('.');
    if (parts.length >= 3 && parts[0] !== 'www') return parts[0];
    return null;
  })();
  const isClientView = subdomain && subdomain !== 'app' && subdomain !== 'www';

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={isClientView ? <Dashboard /> : <Home />} />
        <Route path="/services" element={<Services />} />
<Route path="/how-it-works" element={<Navigate to="/services" />} />
        <Route path="/pricing" element={<Navigate to="/contact" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/client/:id" element={<ClientDetail />} />
        <Route path="/demo" element={<DemoBuilder />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/sign-contract" element={<SignContract />} />
        <Route path="/onboarding" element={<Onboarding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;